<script>
    export let title = '';
    export let subtitle = '';
</script>

<div class="header-large-title" {...$$restProps}>
    <h1 class="title">{title}</h1>
    <h4 class="subtitle">{subtitle}</h4>
</div>
